import { parseSuccessfulResponse, RequestSender } from "./helpers";

type InvoiceNumberInput = {
  readonly prefix: string;
};

async function generateInvoiceNumber(
  request: RequestSender,
  input: InvoiceNumberInput,
): Promise<string> {
  const response = await request("post", `/payment/invoice-numbers`, input);

  return parseSuccessfulResponse(response, (d) => d.invoiceNumber);
}

export default generateInvoiceNumber;
